<template>
<div>
  <div class="radio__label">
   <span>Frequency</span>
	<div class="radio-group" v-if="!onlyMonthly">
		<div class="radio__part">
			<input id="oneTime" type="radio" class="frequency" :checked="type == 'single'" @click="setSingle"/>
			<FormLabel for="oneTime">One time</FormLabel>
		</div>
		<div class="radio__part" v-if="addMonthly">
			<input id="monthly" type="radio" class="frequency" :checked="type == 'monthly'" @click="setMonthly"/>
			<FormLabel for="monthly">Monthly</FormLabel>		
		</div>
		<div class="radio__part" v-if="addSplit">
			<input id="split" type="radio" class="frequency" :checked="type == 'split'" @click="setSplit"/>
			<FormLabel for="split">Split Payment</FormLabel>		
		</div>
	</div>
  <div class="monthly-note" v-if="type === 'split'">
    <select :value="duration" @change="e => setValue('periodMonths', e.target.value)">
      <option v-for="i in splitMonths" :key="i" :value="i">{{i}} {{i == 1 ? 'Month' : 'Months'}}</option>
    </select>
    <div v-if="splitAmount">
      {{splitAmount}}
    </div>
    <div v-else>
      Please select amount to split, and number of months
    </div>
  </div>
   </div>
	<div class="monthly-note"  v-if="type === 'monthly'">    
    <div>
      Your donation will be made today and on the <strong>{{monthDay}}</strong> of each following month using the payment method selected. You may change or cancel this amount at any time.
    </div>
  </div>
</div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  ref,
  watch,
  onMounted
} from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

function round (number: number) {
  return Math.floor(number * 100) / 100
}
export default defineComponent({
  props: {
    addSplit: {
      type: Boolean,
      default: false,
    },
    splitMonths: {
      type: Number,
      default: 12
    },
    addMonthly: {
      type: Boolean,
      default: false
    },
    onlyMonthly: {
      type: Boolean,
      default: false
    },
  },
  setup(props) {
    const { form, setValue } = usePaymentForm()

    const type = ref<'single' | 'monthly' | 'split'>('single')

    const splitAmount = computed(() => {
      if (!form.value.amount) return

      const recurringAmount = Math.round(Number(form.value.amount) / Number(form.value.periodMonths))
    
      const totalAmount = recurringAmount * +form.value.periodMonths!;

      var difference = Number(form.value.amount) - totalAmount;

      var initialAmount = recurringAmount + difference;

      if (initialAmount != recurringAmount) {
        return `One payment of ${form.value.currency == 'ILS'? '₪' : '$'}${initialAmount} and ${+form.value.periodMonths! - 1} payments of ${form.value.currency == 'ILS'? '₪' : '$'}${recurringAmount}`
      }
      else {
        return `${form.value.periodMonths} payments of ${form.value.currency == 'ILS'? '₪' : '$'}${recurringAmount}`
      }
    })

    onMounted(() => {
      if(props.onlyMonthly) {
        type.value = 'monthly'
        setValue('dayOfMonth', ''+new Date().getDate())
        setValue('periodMonths', null)
      }
    })

    function setSingle() {
      type.value = 'single'
      setValue('dayOfMonth', null)
      setValue('periodMonths', null)
    }

    function setMonthly() {
      type.value = 'monthly'
      setValue('dayOfMonth', ''+new Date().getDate())
      setValue('periodMonths', null)
    }

    function setSplit() {
      type.value = 'split'
      setValue('dayOfMonth', null)
      setValue('periodMonths', '2')
    }
    
    return {
      duration: computed(() => form.value.periodMonths),
      setSplit,
      setSingle,
      setMonthly,
      setValue,
      type,
      splitAmount,
      monthDay: computed(() => {
        const i = +form.value.dayOfMonth!

        const j = i % 10,
          k = i % 100
        if (j == 1 && k != 11) {
          return i + 'st'
        }
        if (j == 2 && k != 12) {
          return i + 'nd'
        }
        if (j == 3 && k != 13) {
          return i + 'rd'
        }
        return i + 'th'
      }),
    }
  },
})
</script>
<style scoped lang="scss">
.monthly-note {
  font-size: 13px;
  line-height: 1.4;
  margin-top: 10px;
  display: flex;
  align-items: center;
  select {
    max-width: calc(22% - 10px);
    margin-right: 10px;
    min-width: 120px;
  } 
}

.radio__label{
    display: flex;
   justify-content: space-between;
  align-items: center;
}
.radio-group{
  display: flex;
   gap: 25px;
  align-items: center;
}
.radio__part{
  display: flex;
  gap: 5px;
  align-items: center;
}
</style>